import React from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import Demo from '../Pages/Demo/Demo'
import { DataProvider, useData } from '../Components/DataContext'
import NuevoClienteModal from '../Components/Onboarding/NuevoClienteModal'
import EnConstruccion from '../Pages/EnConstruccion/EnConstruccion'
import { getTenantSlug } from '../Components/paths'

function IndexContenido() {
    const { slugNoEncontrado } = useData();

    if (slugNoEncontrado) return <EnConstruccion slug={getTenantSlug()} />;

    return (
        <>
            <Nabvar />
            <Demo />
            <NuevoClienteModal />
        </>
    );
}

export default function IndexLayout() {
    return (
        <DataProvider autoLoad={['bootstrap']}>
            <div className='section-bg-color'>
                <IndexContenido />
            </div>
        </DataProvider>
    );
}
